<style src="./styles/app/app.scss" lang="scss"></style>

<template lang="pug">
   #app
        router-view
        vuedal
</template>

<script>
import gql from "graphql-tag";
import { Component as Vuedal } from "vuedals";
import cookie from "@/components/libraries/cookie";

export default {
	name: "App",
	components: {
		Vuedal
	},
	apollo: {
		User: {
			query: gql`
				{
					User {
						id
						is_admin
						is_teacher
						is_free_teacher
						is_organisation_admin
					}
				}
			`,
			update(res) {
				window.Intercom("shutdown");

				if (res.User && (res.User.is_admin || res.User.is_teacher || res.User.is_free_teacher || res.User.is_organisation_admin)) {
					window.Intercom("boot", {
						app_id: "salq7gk9"
					});
				}
			},
			skip() {
				return !cookie.doesLoginCookieExist();
			}
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/App.vue